import React from "react";

type Props = {};

const NotAuthorizedPage = (props: Props) => {
  return (
    <div className="h-full w-full flex justify-center items-center text-secondary-main text-xl font-medium">
      Not Authorized
    </div>
  );
};

export default NotAuthorizedPage;
